import React, { FC } from 'react'
import styled from 'styled-components'

const StyledImage = styled.img`
`

const Image: FC<IconButtonProps> = ({ ...props }) => <StyledImage {...props} />

export default Image
